import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../navigation/Sidebar'; // El sidebar izquierdo existente (w-20)
import ChatSidebar from '../chat/ChatSidebar'; // El sidebar de historial de chats existente
import Header from './Header'; // El header de app existente (el complejo que vimos)
import { useStore } from '../../store/useStore';

const MainLayout = () => {
  const isRightSidebarOpen = useStore((state) => state.isRightSidebarOpen);
  const selectedAgent = useStore((state) => state.selectedAgent);

  // El ChatSidebar (historial) solo debe ser visible si isRightSidebarOpen es true Y hay un agente seleccionado.
  // El botón en Header.js controlará isRightSidebarOpen.
  const isChatSidebarActuallyVisible = isRightSidebarOpen && selectedAgent;

  return (
    <div className="flex h-screen bg-gray-100 dark:bg-gray-900">
      <Sidebar /> {/* Sidebar Izquierdo (w-20) */}
      
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* El Header existente (../navigation/Header.js) va aquí */}
        {/* Este Header ya tiene su propio padding, sombra, etc. y se espera que ocupe el ancho de esta columna. */}
        <Header /> 
        
        {/* Área de Contenido Principal */}
        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-100 dark:bg-gray-900">
          {/* Padding puede ser añadido aquí o dentro de las páginas que renderiza Outlet si es necesario */}
          <Outlet /> {/* Aquí se renderizará ChatArea.js u otras vistas del dashboard */}
        </main>
      </div>

      {/* Sidebar Derecho (Historial de Chats), controlado por isRightSidebarOpen y selectedAgent */}
      {/* ChatSidebar internamente también verifica 'isOpen' prop y selectedAgent para mostrar contenido */}
      <ChatSidebar isOpen={isChatSidebarActuallyVisible} /> 
    </div>
  );
};

export default MainLayout;
